export const LOYALTY_PASS_DESCRIPTION = 'Add loyalty pass to your wallet & never miss out on rewards.';
